import { connect } from 'react-redux';

import { getCurrentUserRolesSelector } from 'selectors/user';
import { isAdmin } from 'utils/user';
import { getHasPhoneTabsSelector, getCompanyTabsSelector } from 'selectors/company';
import TourInfos from './index';

const mapStateToProps = state => {
    const roles = getCurrentUserRolesSelector(state);
    const hasPhone = getHasPhoneTabsSelector(state);
    const tabs = getCompanyTabsSelector(state);
    const hasDashboard = tabs?.some(tab => tab?.name?.toLowerCase() === 'dashboard');
    const hasProfile = tabs?.some(tab => tab?.name?.toLowerCase() === 'profile');
    const hasContacts = tabs?.some(tab => tab?.name?.toLowerCase() === 'contacts');
    const hasSearch = tabs?.some(tab => tab?.name?.toLowerCase() === 'search');
    const hasNeoConnect = tabs?.some(tab => tab?.name?.toLowerCase() === 'neoconnect');

    return {
        hasPhone,
        hasDashboard,
        hasProfile,
        hasContacts,
        hasSearch,
        hasNeoConnect,
        isAdmin: !!isAdmin(roles),
    };
};

export default connect(
    mapStateToProps,
    null
)(TourInfos);
